<article class="container">
    <div class="headline">
        <app-spot-headline *ngIf="data.headlineText as headlineText" [index]="data.spotIndex">{{ headlineText }}</app-spot-headline>
    </div>
    <div class="row">
        @if (listOfProducts$ | async; as products) {
            @for (product of products.products; track product.productNo) {
                <div class="product-card col-12 col-sm-6 col-md-3 col-lg-3">
                    <app-product-card
                        [line]="product"
                        [index]="$index + 1"
                        [displayActions]="true"
                        impressionSource="By Product Id"
                    ></app-product-card>
                </div>
            }
        }
    </div>
</article>
